import { CategoryInspirationResource } from './CategoryInspirationResource';
import { KioskListResource } from './KioskListResource';
import { BlogAndKioskResource } from './BlogAndKioskResource';

export class BlogResource {
	rid: number;
	titleRo: string;
	titleEn: string;
	titleFr: string;
	titleDe: string;
	descriptionRo: string;
	descriptionEn: string;
	descriptionFr: string;
	descriptionDe: string;
	image: string;
	imageString: string;
	principal: boolean = false;
	categories: CategoryInspirationResource[];
	createdDate: string;
	errorCode: number;
	errorMessage: string;
	shortDescriptionRo: string;
	shortDescriptionEn: string;
	shortDescriptionFr: string;
	shortDescriptionDe: string;
	tagFr: string;
	tagEn: string;
	tagRo: string;
	tagDe: string;
	kioskResourceList: BlogAndKioskResource[];

	showDetailsOnResponsive: boolean = false;
	showDelete:boolean= false;
}